<template>
    <div class="modal fade">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">{{ title }}</h4>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Close</button>
                    <button type="button" v-if="button" @click="onClick" class="btn btn-primary">{{ button }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'

    export default {
        props: ['show', 'title', 'button'],
        methods: {
            onClick() {
                this.$emit('onModalClick')
            }
        },
        mounted() {
            $(this.$el).on('hidden.bs.modal', () => {
                this.$emit('onModalHidden')
            });
            $(this.$el).on('shown.bs.modal', () => {
                this.$emit('onModalShown')
            });
            $(this.$el).on('hide.bs.modal', () => {
                this.$emit('onModalHide')
            });
            $(this.$el).on('show.bs.modal', () => {
                this.$emit('onModalShow')
            });
        },
        watch: {
            show(a, b) {
                $(this.$el).modal(a ? 'show' : 'hide')
            }
        }
    }
</script>

<style>
    .modal-large .modal-dialog {
        width: 80%;
    }
</style>
